
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { AuthService } from "../../services/auth.service";
import { ToastrService } from 'ngx-toastr';
import { debounceTime } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html' 
})
export class LoginComponent implements OnInit {
  formModel = {
    Login: '',
    Password: ''
  }

  constructor(private translate: TranslateService, private service: UserService, private router: Router, private authService: AuthService, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.service.logginEvent.emit();
    this.router.navigateByUrl('/activation');
  }
 
  onSubmit(form: NgForm) {
    this.spinner.show();
    this.service.login(form.value).pipe(debounceTime(800)).subscribe(
      (res: any) => {
        
        this.service.logginEvent.emit();
        this.authService.setToken(res.token);
              
        this.router.navigateByUrl('/activation');
        this.toastr.success(this.translate.instant("USER.LOGIN") + " " + this.translate.instant("COM.SUCCESSFUL"), "");
        this.spinner.hide();
       
      },
      err => {
        this.spinner.hide();       
        if (err.status == 400) { }
        else console.log(err);
        
      }      
    );
    

  }

}
